<div mat-dialog-title>Import Model, Label and Gains Threshold Assignments<button class="close" mat-button mat-dialog-close (click)="close()"><i class="material-icons clear" >clear</i></button></div>
<mat-dialog-content>
  <mat-card *ngIf="hasFile && !isValidFile" class="error block">
      <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
      <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;" >{{invalidFileErrorMessage}}</mat-card-subtitle>
    </mat-card>
  <mat-card *ngIf="errorMessage" class="error block">
      <mat-card-title class="error">An error occurred.</mat-card-title>
      <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;">{{errorMessage}}</mat-card-subtitle>
    </mat-card>
  <div>You can use this import to assign models, labels, or gains threshold to your portfolios.
    Note: If you leave the label blank in your upload, the existing labels will not be overwritten.
  </div>
  <div>
    <table class="import" width="100%">
      <tr>
        <th align="left" style="vertical-align: top;"><label>File name</label></th>
        <td>
          <div class="bottomPaddingElementDialog">
            <irb-file-selector (change)="onFileChange($event)"></irb-file-selector>
            <div>File type must be .csv</div>
          </div>
        </td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
        <td><div class="block">Your selected file must be in .csv format and follow iRebal's format, which is: Portfolio Name, Model, Labels, Gains Threshold</div></td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Template</label></th>
        <td>
          <div>Use our .csv template to prepare your file.<br/>
            <a href='/assets/template/Portfolio_Model_Labels_Gains.xlsx'>Download template: Portfolio_Model_Labels_Gains.xlsx</a></div>
          </td>
        </tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
    <button id="continueButton" (click)="submitFile()" [disabled]="!(hasFile && isValidFile)" class="btn-medium-primary">Continue</button>
  </mat-dialog-actions>